import { jsxs as i, jsx as a, Fragment as D } from "react/jsx-runtime";
import { R as O, b as R, P as j, O as I, C as M, T as B, a as n, D as E } from "./index-PFltbIyu.js";
import { R as F } from "./index-BMQ7iO4X.js";
import { c as l } from "./clsx-OuTLNxxd.js";
import { B as _ } from "./button.types-BqgkEc5r.js";
import "./components/elements/button/iconButton/iconButton.js";
import "react";
import { Flex as L } from "./components/layout/flex/flex.js";
import { I as P } from "./icon-B72I4fRl.js";
import "./components/elements/icon/iconsList.js";
import "./components/elements/tag/tag.js";
import "./components/elements/carousel/carousel.js";
import "./components/elements/inputs/input/input.js";
import "./components/elements/inputs/checkbox/checkbox.js";
import "./phoneNumber-uA-pVPpW.js";
import "./components/elements/inputs/dateRangePicker/dateRangePicker.js";
import { Divider as v } from "./components/elements/divider/divider.js";
import { StepperDots as T } from "./components/elements/stepperDots/stepperDots.js";
import "./components/elements/toast/toast.context.js";
import "./map-aaRj3EBU.js";
const z = "_modal_16va0_29", o = {
  "modal-overlay": "_modal-overlay_16va0_29",
  "dialog-overlay-show": "_dialog-overlay-show_16va0_1",
  modal: z,
  "dialog-content-slide-up": "_dialog-content-slide-up_16va0_1",
  "dialog-content-show": "_dialog-content-show_16va0_1",
  "is-small": "_is-small_16va0_67",
  "is-medium": "_is-medium_16va0_70",
  "is-large": "_is-large_16va0_73",
  "modal-bottom": "_modal-bottom_16va0_80",
  "modal-title": "_modal-title_16va0_84",
  "is-closable": "_is-closable_16va0_99",
  "outer-modal-content": "_outer-modal-content_16va0_103",
  "is-overflow-inherit": "_is-overflow-inherit_16va0_108",
  "modal-content": "_modal-content_16va0_111",
  "modal-actions": "_modal-actions_16va0_133",
  "no-dividers": "_no-dividers_16va0_147",
  "no-alternative-action": "_no-alternative-action_16va0_150",
  "no-alternative-action-multi-steps": "_no-alternative-action-multi-steps_16va0_153",
  "modal-actions-confirm": "_modal-actions-confirm_16va0_156",
  "modal-actions-confirm-no-alternative-action": "_modal-actions-confirm-no-alternative-action_16va0_164",
  "confirm-cta": "_confirm-cta_16va0_167",
  "modal-close": "_modal-close_16va0_176",
  "stepper-dots-container": "_stepper-dots-container_16va0_184"
};
function so({
  size: p = "medium",
  title: h,
  description: r,
  onChange: f,
  children: g,
  dialogTriggerNode: u,
  alternativeAction: t,
  confirmActionText: m,
  confirmActionLoading: C,
  onConfirmAction: y,
  confirmActionDisabled: N,
  isOpen: k,
  areDividersVisible: s = !0,
  isClosable: c = !1,
  onClose: d,
  multiSteps: e,
  onInteractOutside: w,
  isOverflowInherit: b = !1
}) {
  const x = l(o.modal, o[K[p]]);
  return /* @__PURE__ */ i(O, { open: k, onOpenChange: f, children: [
    /* @__PURE__ */ a(R, { asChild: !0, children: u }),
    /* @__PURE__ */ i(j, { children: [
      /* @__PURE__ */ a(I, { className: o["modal-overlay"] }),
      /* @__PURE__ */ i(M, { className: x, onInteractOutside: w, onEscapeKeyDown: d, children: [
        /* @__PURE__ */ i("div", { children: [
          /* @__PURE__ */ a(B, { className: l(o["modal-title"], c && o["is-closable"]), children: h }),
          c && /* @__PURE__ */ a(n, { className: o["modal-close"], onClick: d, "aria-label": "Close", children: /* @__PURE__ */ a(P, { name: "remove", size: "large" }) }),
          r && /* @__PURE__ */ a(F, { asChild: !0, children: /* @__PURE__ */ a(E, { children: r }) })
        ] }),
        s && /* @__PURE__ */ a(v, { space: "no" }),
        /* @__PURE__ */ a("div", { className: l(o["outer-modal-content"], b && o["is-overflow-inherit"]), children: /* @__PURE__ */ a("div", { className: o["modal-content"], children: g }) }),
        e?.displayDots && /* @__PURE__ */ a("div", { className: o["stepper-dots-container"], children: /* @__PURE__ */ a(T, { currentStep: e.currentStep, stepsCount: e.stepNumber }) }),
        m && /* @__PURE__ */ i(D, { children: [
          s && /* @__PURE__ */ a(v, { space: "no", className: e?.displayDots ? "" : o["modal-bottom"] }),
          /* @__PURE__ */ i(
            "div",
            {
              className: l(
                o["modal-actions"],
                !s && !e?.displayDots && o["no-dividers"]
              ),
              children: [
                t && /* @__PURE__ */ a(n, { asChild: !0, children: t }),
                /* @__PURE__ */ a(n, { asChild: !0, children: /* @__PURE__ */ i(
                  L,
                  {
                    className: t ? o["modal-actions-confirm"] : o["modal-actions-confirm-no-alternative-action"],
                    justifyContent: "end",
                    gap: "2",
                    children: [
                      e?.skip && /* @__PURE__ */ a(_, { onClick: e.skip.onClick, text: e.skip.text, color: "ghost" }),
                      /* @__PURE__ */ a(
                        _,
                        {
                          onClick: y,
                          disabled: N,
                          className: l(
                            o["confirm-cta"],
                            e && !t && !e.skip && o["no-alternative-action-multi-steps"],
                            !e && !t && o["no-alternative-action"]
                          ),
                          text: m,
                          isLoading: C
                        }
                      )
                    ]
                  }
                ) })
              ]
            }
          )
        ] })
      ] })
    ] })
  ] });
}
const K = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
};
export {
  so as M,
  K as a
};
